import { getSupplierUnreadMessage } from "../../api/merchant/merchant";
import VueCookies from 'vue-cookies'

const state = {
    order_count: 0,
    customer_count: 0,
    pay_count: 0,
    collect_count: 0,
    return_count: 0
}

const getters = {}

const mutations = {
    changeOrderCount(state, a) {
        state.order_count = a
    },
    changeCustomerCount(state, a) {
        state.customer_count = a
    },
    changePayCount(state, a) {
        state.pay_count = a
    },
    changeCollectCount(state, a) {
        state.collect_count = a
    },
    changeReturnCount(state, a) {
        state.return_count = a
    }
}

const actions = {
    changeCountAction(context) {
        var params = {
            user_id: VueCookies.get("uid"),
            browser_token: VueCookies.get("browser_token"),
            supplier_id: VueCookies.get("supplier_id")
        };
        getSupplierUnreadMessage(params).then(res => {
            var data = res.data.data
            context.commit('changeOrderCount', data.order_count)
            context.commit('changeCustomerCount', data.customer_count)
            context.commit('changePayCount', data.pay_count)
            context.commit('changeCollectCount', data.collect_count)
            context.commit('changeReturnCount', data.return_count)
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/merchantOrder.js